import styled from 'styled-components';


export const QuestionnairesPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: ${props => (props.isWidgetActiveTab ? 'none' : 'block')};
`
